/* Index_object_flavors_item_marquee */
/*initMarquee('.Index_object_flavors_item_marquee', {
    mobile: {
        duration: 50000,
        gap: 0,
        duplicated: true,
        direction: "right"
    },
    desktop: {
        duration: 80000,
        gap: 0,
        duplicated: true,
        direction: "right"
    }
});*/
/* Index_object_flavors_item_marquee */

document.querySelectorAll('.Index_object_flavors_item_slider').forEach(el => {
  if (!el.classList.contains('swiper-initialized')) {
    new Swiper(el, {
        loop: false,
        grabCursor: true,
        spaceBetween: 40,
        slidesPerGroup: 1,
        slidesPerView: "auto",
        watchSlidesProgress: true,
        draggable: !0,
        autoHeight: !1,
        watchOverflow: !0,
        threshold: 10,
        mousewheel: {
            forceToAxis: !0
        },
        observer: true,
        observeParents: true,
        freeMode: !0,
        a11y: {
            slideRole: '',
            slideLabelMessage: ''
        },
        breakpoints: {
            0: {
                spaceBetween: 20,
                freeMode: !1
            },
            750: {
                spaceBetween: 30,
            },
            990: {
                spaceBetween: 40,
            },
            1200: {
            },
            1440: {
            }
        }
    })
  }
});